import React from 'react';
import { Helmet } from 'react-helmet-async';
import PAGE_SEO, { DEFAULT_SEO } from '../../Data/seoConfig';
import SITE from '../../Data/siteConfig';

const PageSEO = ({ pageKey = 'home' }) => {
  const seo = PAGE_SEO[pageKey] || PAGE_SEO.home;
  const canonical = seo.path ? `${SITE.url}${seo.path}` : SITE.url;

  return (
    <Helmet>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      {seo.keywords && <meta name="keywords" content={seo.keywords} />}
      {seo.path && <link rel="canonical" href={canonical} />}
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content={DEFAULT_SEO.locale} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={DEFAULT_SEO.ogImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
    </Helmet>
  );
};

export default PageSEO;
